module.exports = __webpack_public_path__ + "img/btn_taiwan_on.dd80bf1f.png";